import { Injectable } from '@angular/core';
import { Network } from '@awesome-cordova-plugins/network/ngx';



@Injectable({
  providedIn: 'root'
})
export class NetworkService {


  constructor(private network: Network) {
  }

  watchNetworkChange() {
    return this.network.onChange();
  }

}
